import { useQuery } from '@tanstack/react-query';
import React from 'react';

import envVars from '../../../constants/envVars';
import useRequest from '../../../hooks/useRequest';
import { UnreadSmsItem } from '../types';
import { UNREAD_SMS_LIST } from './constants';

const useGetUnreadSmsList = ({ enabled = true }: { enabled?: boolean } = {}) => {
    const req = useRequest();

    const request = React.useCallback(() => {
        return req<UnreadSmsItem[]>({
            url: `${envVars.API_RTM_HOSTNAME}enterprise/sms/unread/`
        });
    }, [req]);

    return useQuery({
        queryFn: request,
        queryKey: [UNREAD_SMS_LIST],
        enabled
    });
};

export default useGetUnreadSmsList;
